import { gql } from '@apollo/client';

export const CreateSubscription = gql(`
    mutation createSubscription(
        $email: String!
        $priceId: String!
        $isTrial: Boolean! = false
        $paymentMethodId: String = null
    ) {
        createSubscription(email: $email, priceId: $priceId, isTrial: $isTrial, paymentMethodId: $paymentMethodId) {
            success
            clientSecret
            subscriptionId
            paymentId
            error
        }
    }
`);
